import { render, staticRenderFns } from "./Serial.vue?vue&type=template&id=71525e1a&"
import script from "./Serial.vue?vue&type=script&lang=js&"
export * from "./Serial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports